// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__2peeB","withImage":"Tag_withImage__23B3v","image":"Tag_image__1xE3i","closeable":"Tag_closeable__3DrvT"};